import { useAxiosPrivate } from "./axios";

const LIST_QUERY = "/customer/list";

export const useListCustomers = () => {
  const listCustomers = async (callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        paramsSerializer: {
          indexes: null,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return listCustomers;
};
